export interface ListTreatmentAssignmentRulesParams {
    readonly treatmentTypeOriginalId?: number | null;
    readonly isActive?: boolean | null;
    readonly search?: string | null;
    readonly designerUserId?: string | null;
}
